import {del, get, set} from 'idb-keyval'
import {create} from 'zustand'
import {createJSONStorage, persist} from 'zustand/middleware'

function randomUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

const IDBStorage = {
    getItem: async name => {
        if (typeof window !== 'undefined') {
            return (await get(name)) || null
        }
        return null
    },
    setItem: async (name, value) => {
        if (typeof window !== 'undefined') {
            await set(name, value)
        }
    },
    removeItem: async name => {
        if (typeof window !== 'undefined') {
            await del(name)
        }
    },
}

export const useChatStore = create(
    persist(
        set => ({
            hasHydrated: false,

            sessionId: randomUUID(),

            accessToken: null,
            setAccessToken: accessToken => set({accessToken}),

            systemUser: null,
            setSystemUser: systemUser => set({systemUser}),

            lastBotResponseTime: null,
            setLastBotResponseTime: time => set({lastBotResponseTime: time}),

            startStatusCheck: null,
            setStartStatusCheck: startStatusCheck => set({startStatusCheck}),

            vendorRegistrationId: null,
            setVendorRegistrationId: vendorRegistrationId => set({vendorRegistrationId}),

            clearStore: () => set({
                sessionId: randomUUID(),
                accessToken: null,
                systemUser: null,
                lastBotResponseTime: null,
                startStatusCheck: null,
                vendorRegistrationId: null
            }),
        }),
        {
            name: 'chat-storage',
            storage: createJSONStorage(() => IDBStorage),
            onRehydrateStorage: () => state => {
                useChatStore.setState({hasHydrated: true})
            },
        }
    )
)
